<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center flex-justify-sb">
            <h1 class="h1 cabinet-title">Изделия</h1>
            <a
                href="javascript:void(0)"
                class="cabinet-link text-bold-important ml-auto mr-4 d-none d-lg-block"
                @click="isOpenManageCollection = true"
                >Управление коллекциями</a
            >
            <div
                v-click-outside="closeManageCollectionsSubmenu"
                class="ml-auto mr-4 d-lg-none position-relative"
                @click="toggleManageCollectionsSubmenu"
            >
                <button
                    type="button"
                    class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--more-hor-blue d-block"
                ></button>

                <div
                    v-if="isOpenManageCollectionsSubmenu"
                    class="app-dropdown app-dropdown--bottom app-dropdown--right js-dropdown"
                >
                    <a
                        href="javascript:void(0)"
                        class="app-dropdown__item text-nowrap"
                        @click.prevent="isOpenManageCollection = true"
                        >Управление коллекциями</a
                    >
                </div>
            </div>

            <router-link
                :to="{ name: 'SupplierProductsAdd' }"
                tag="button"
                class="cabinet-btn cabinet-btn--add cabinet-btn--add-white d-none d-md-block"
                >Добавить изделие</router-link
            >
            <router-link
                :to="{ name: 'SupplierProductsAdd' }"
                tag="button"
                class="cabinet-btn cabinet-btn--icon cabinet-btn--plus d-md-none"
            ></router-link>
        </header>

        <section
            class="filters-panel filters-panel--border-bottom row filters-panel__row"
        >
            <div class="col-lg-5 filters-panel__col d-flex d-lg-block">
                <div class="filters-panel-search">
                    <label
                        class="filters-panel-search__label"
                        for="filters-panel-search__input"
                        @click="onSearch"
                    ></label>
                    <input
                        id="filters-panel-search__input"
                        v-model="search"
                        type="text"
                        name=""
                        class="app-input filters-panel-search__input"
                        placeholder="Поиск"
                        @keyup.enter="onSearch"
                    />
                    <label
                        v-if="search"
                        class="filters-panel-search__clear"
                        for="filters-panel-search__input"
                        @click="onClearSearch"
                    ></label>
                </div>
                <div class="position-relative d-lg-none">
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default filters-panel__mob-btn d-lg-none ml-3 js-open-mob-filters"
                        @click="level1mFilter = true"
                    >
                        Фильтры
                    </button>
                    <div
                        v-if="appliedFiltersCount"
                        class="mobile-filter__selected-label mobile-filter__selected-label--circle"
                    >
                        {{ appliedFiltersCount }}
                    </div>
                </div>
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.categories.value"
                    :options="categories"
                    key-value="CategoryID"
                    key-title="Name"
                    select-title="Категория"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('categories', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.types.value"
                    :options="typesByCategories"
                    key-value="TypeID"
                    key-title="Name"
                    select-title="Вид изделия"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('types', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.materials.value"
                    :options="materials"
                    key-value="MaterialID"
                    key-title="Name"
                    select-title="Материал"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('materials', $event)"
                />
            </div>

            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.finenesses.value"
                    :options="finenessesByMaterials"
                    key-value="FinenessID"
                    key-title="Value"
                    select-title="Проба"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('finenesses', $event)"
                />
            </div>
            <div class="col-lg-3 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.insertMaterials.value"
                    :options="insertMaterials"
                    key-value="MaterialID"
                    key-title="Name"
                    select-title="Материал вставки"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('insertMaterials', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.collections.value"
                    :options="supplierCollections"
                    key-value="CollectionID"
                    key-title="Name"
                    select-title="Коллекция"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('collections', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.visibility.value"
                    :options="supplierVisibility"
                    key-value="id"
                    key-title="title"
                    select-title="Видимость"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('visibility', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <button
                    v-if="!isAllDefaultValues"
                    type="button"
                    class="cabinet-btn cabinet-btn--default"
                    @click="resetFilters()"
                >
                    Сбросить
                </button>
            </div>
        </section>

        <section>
            <div
                class="flex flex-column flex-justify-sb mobile-filter"
                :class="{ 'mobile-filter--open': level1mFilter }"
            >
                <div class="mobile-filter__wrap">
                    <div
                        class="flex flex-justify-sb flex-align-center mobile-filter__header"
                    >
                        <div class="h3 mobile-filter__title">
                            Фильтр
                            <span class="mobile-filter__selected-count"></span>
                        </div>
                        <button
                            type="button"
                            class="mobile-filter__close-btn"
                            @click="level1mFilter = false"
                        ></button>
                    </div>

                    <ul class="mobile-filter__list">
                        <li
                            v-for="(filterKey, i) in Object.keys(filter)"
                            :key="i"
                            class="mobile-filter__list-item"
                            @click="setlevel2mFilters(filterKey)"
                        >
                            <div class="d-flex justify-content-between">
                                {{ filter[filterKey].title }}
                                <div
                                    v-if="!filter[filterKey].isDefault"
                                    class="mobile-filter__selected-label d-flex align-items-center"
                                >
                                    {{ filter[filterKey].value.length }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="d-flex p-3 mobile-filter__footer">
                    <button
                        type="button"
                        class="cabinet-btn mr-3"
                        @click="level1mFilter = false"
                    >
                        Показать
                    </button>
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        @click="resetFilters()"
                    >
                        Сбросить
                    </button>
                </div>
            </div>

            <div
                v-if="!!level2mFilter"
                id="mobile-filter-level2"
                class="flex flex-column flex-justify-sb mobile-filter"
                :class="{ 'mobile-filter--open': !!level2mFilter }"
            >
                <div class="mobile-filter__wrap">
                    <div
                        class="flex flex-justify-sb flex-align-center mobile-filter__header"
                    >
                        <button
                            type="button"
                            class="mobile-filter__back-btn"
                            @click="level2mFilter = false"
                        ></button>
                        <div class="h3 mobile-filter__title">
                            {{ filter[level2mFilter].title }}
                        </div>
                        <div></div>
                    </div>

                    <ul class="mobile-filter__list">
                        <!-- {{ this[filter[level2mFilter].srcName] }} -->
                        <!-- eslint-disable -->
                        <li
                            v-for="(item, i) in this[
                                filter[level2mFilter].srcName
                            ]"
                            :key="i"
                            class="mobile-filter__list-item"
                        >
                            <label class="custom-checkbox"
                                >{{ item[filter[level2mFilter].srcKeyTitle] }}
                                <input
                                    v-model="filter[level2mFilter].value"
                                    type="checkbox"
                                    :value="
                                        item[filter[level2mFilter].srcKeyVal]
                                    "
                                    @change="onFilterChange(level2mFilter)"
                                />
                                <span class="custom-checkbox__checkmark"></span>
                            </label>
                        </li>
                        <!-- eslint-enable -->
                    </ul>
                </div>

                <div class="d-flex p-3 mobile-filter__footer">
                    <button
                        type="button"
                        class="cabinet-btn mr-3"
                        @click="closeAllmFilters"
                    >
                        Показать
                    </button>
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        @click="resetFilters()"
                    >
                        Сбросить
                    </button>
                </div>
            </div>
        </section>

        <div v-if="loading">Loading...</div>

        <div v-else-if="errors.getProducts">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="tryLoadingProducts"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>
        <div
            v-else-if="!paginatedProducts.length"
            class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
        >
            <img
                v-if="search.length === 0"
                src="/img/icons/empty-goods.svg"
                class="dashboard-empty__img ofi"
            />
            <img
                v-else
                src="/img/icons/empty-search.svg"
                class="dashboard-empty__img dashboard-empty__img--search ofi"
            />
            <div class="dashboard-empty__title pt-5">
                {{
                    search || !isAllDefaultValues
                        ? ' По вашему запросу ничего не найдено.'
                        : 'У вас пока что нет ни одного изделия.'
                }}
            </div>
        </div>

        <div v-show="!loading && paginatedProducts.length">
            <section class="cabinet-table-options-wrap">
                <span class="d-none d-lg-inline-block">
                    {{
                        pagination.page * pagination.pageSize +
                            1 -
                            pagination.pageSize
                    }}
                    -
                </span>
                {{
                    Math.min(
                        pagination.page * pagination.pageSize,
                        pagination.totalProducts
                    )
                }}

                из {{ pagination.totalProducts }}

                <div
                    class="cabinet-table-options flex flex-justify-sb flex-align-center"
                >
                    <div
                        class="cabinet-table-options__delete flex flex-align-center"
                    >
                        <label
                            class="cabinet-cart-checkbox cabinet-cart-checkbox--no-label cabinet-cart-checkbox--count"
                        >
                            <input
                                id="table-items"
                                type="checkbox"
                                :checked="selectedProducts.length"
                                @change="onSelectAllProducts"
                            />
                            <span
                                class="cabinet-cart-checkbox__checkmark"
                            ></span>
                            <span
                                v-show="selectedProducts.length"
                                class="cabinet-cart-checkbox__count"
                            >
                                {{ selectedProducts.length }}
                            </span>
                        </label>
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default mr-3 js-delete-table-item d-none d-md-block"
                            :disabled="!selectedProducts.length"
                            @click="isOpenChangeVisibilityMass = true"
                        >
                            Изменить видимость
                        </button>
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default mr-3 js-delete-table-item d-none d-md-block"
                            :disabled="
                                !selectedProducts.length ||
                                    !massCollectionBrandId
                            "
                            @click="isOpenChangeCollectionMass = true"
                        >
                            Изменить коллекцию
                        </button>
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default mr-3 js-delete-table-item d-none d-md-block"
                            :disabled="
                                !selectedProducts.length ||
                                    selectedProducts.length > 6 ||
                                    !isMassCategoryCorrect ||
                                    !massCollectionBrandId
                            "
                            @click="isOpenChangeGarnitureMass = true"
                        >
                            Объединить в гарнитур
                        </button>
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default js-delete-table-item d-none d-md-block"
                            :disabled="!selectedProducts.length"
                            @click="isOpenDeleteMass = true"
                        >
                            Удалить
                        </button>

                        <select-picker
                            current-value=""
                            :options="mobileMassActions"
                            key-value="id"
                            key-title="title"
                            select-width="130px"
                            select-title="Действия"
                            :classes="['select', 'd-md-none']"
                            :disabled="!selectedProducts.length"
                            @onChange="onMobileActionSelect($event)"
                        />
                    </div>

                    <div class="d-none d-lg-block">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalProducts"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                </div>
            </section>

            <section class="cabinet-supplier-table">
                <supplier-product-item
                    v-for="product in paginatedProducts"
                    :key="product.ItemID"
                    :product="product"
                    :checked="selectedProducts.indexOf(product.ItemID) > -1"
                    @onSelectProductsChange="onSelectProducts($event)"
                    @changeProductVisibility="onChangeProductVisibility($event)"
                    @changeProductCollection="onChangeProductCollection($event)"
                    @deleteProduct="onDeleteProduct($event)"
                ></supplier-product-item>
            </section>

            <section
                class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-lg-flex"
            >
                <select-picker
                    :current-value="pagination.pageSize"
                    :options="pageSizes"
                    key-value="id"
                    key-title="title"
                    select-width="80"
                    :classes="['select', 'select--small']"
                    @onChange="onPageSizeChange($event)"
                />

                <table-pagination
                    :current-page="pagination.page"
                    :total-pages="pagination.totalPages"
                    :total-products="pagination.totalProducts"
                    @setPage="onSetPage($event)"
                />
            </section>

            <section
                v-if="pagination.page < pagination.totalPages"
                class="cabinet-pagination flex flex-column flex-align-center d-lg-none"
            >
                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default"
                    :disabled="pagination.page >= pagination.totalPages"
                    @click="updateProductsList(pagination.page + 1, true)"
                >
                    Загрузить еще
                </button>
            </section>
        </div>

        <change-visibility-mass
            :is-open="isOpenChangeVisibilityMass"
            :product-ids="selectedProducts"
            @closeModal="onCloseChangeVisibilityMass"
            @onChangeVisibilityMassSaved="onChangeVisibilityMassSaved"
        />
        <delete-mass
            :is-open="isOpenDeleteMass"
            :product-ids="selectedProducts"
            @closeModal="onCloseDeleteMass"
            @onDeleteMassSaved="onDeleteMassSaved"
        />
        <change-collection-mass
            :is-open="isOpenChangeCollectionMass"
            :product-ids="selectedProducts"
            :brand-id="massCollectionBrandId"
            @closeModal="onCloseChangeCollectionMass"
            @onAddCollectionClick="onAddCollectionClick($event)"
            @onChangeCollectionMassSaved="onChangeCollectionMassSaved"
        />
        <change-garniture-mass
            :is-open="isOpenChangeGarnitureMass"
            :product-ids="selectedProducts"
            :brand-id="massCollectionBrandId"
            @closeModal="onCloseChangeGarnitureMass"
            @onChangeGarnitureMassSaved="onChangeGarnitureMassSaved"
        />
        <manage-collection
            :is-open="isOpenManageCollection"
            @closeModal="isOpenManageCollection = false"
            @onAddCollectionClick="onAddCollectionClick($event)"
            @openDeleteCollection="openDeleteCollection($event)"
            @openUpdateCollection="openUpdateCollection($event)"
        />
        <create-collection
            :is-open="isCreateCollectionOpen"
            :brand-id="createCollectionBrandId"
            :collection-id="manageCollectionId"
            prev-modal-name="previousModalName"
            :back-btn="true"
            :is-select-brand-disabled="!canChangeBrandForCollection"
            @closeModal="onCreateCollectionClose()"
            @backModal="onCreateCollectionBack()"
            @onCreateCollection="onCreateCollectionSave($event)"
            @onUpdateCollection="onCreateCollectionSave($event)"
        />
        <delete-collection
            :is-open="isOpenDeleteCollection"
            :collection-id="manageCollectionId"
            @closeModal="onDeleteCollectionClose()"
            @onDeleteCollection="onDeleteCollectionSave"
        />
    </div>
</template>

<script>
// import jq from '@/mixins/jq'
import _ from 'lodash'
import ClickOutside from 'vue-click-outside'
import SupplierProductItem from '@/components/Cabinet/Supplier/ProductItem'
import SelectPicker from '@/components/Elements/SelectPicker'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import ChangeVisibilityMass from '@/components/Cabinet/Supplier/MassActions/ChangeVisibilityMass'
import DeleteMass from '@/components/Cabinet/Supplier/MassActions/DeleteMass'
import ChangeCollectionMass from '@/components/Cabinet/Supplier/MassActions/ChangeCollectionMass'
import ManageCollection from '@/components/Cabinet/Supplier/Collection/ManageCollection'
import CreateCollection from '@/components/Cabinet/Supplier/Collection/CreateCollection'
import DeleteCollection from '@/components/Cabinet/Supplier/Collection/DeleteCollection'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import initSelectPicker from '@/mixins/initSelectPicker'
import getNameById from '@/mixins/getNameById'
import onResize from '@/mixins/on-resize'
import ChangeGarnitureMass from '@/components/Cabinet/Supplier/MassActions/ChangeGarnitureMass'

let pageSizes = [10, 20, 50, 100].map(item => {
    return {
        id: item,
        title: item
    }
})

let mobileMassActions = [
    {
        id: 0,
        title: 'Изменить видимость'
    },
    {
        id: 1,
        title: 'Изменить коллекцию'
    },
    {
        id: 3,
        title: 'Объединить в гарнитур'
    },
    {
        id: 2,
        title: 'Удалить'
    }
]

export default {
    name: 'SupplierProducts',
    components: {
        SupplierProductItem,
        SelectPicker,
        TablePagination,
        ChangeVisibilityMass,
        DeleteMass,
        ChangeCollectionMass,
        ManageCollection,
        CreateCollection,
        DeleteCollection,
        ChangeGarnitureMass
    },
    directives: {
        ClickOutside
    },
    mixins: [initSelectPicker, getNameById, onResize],
    data() {
        return {
            search: '',
            filter: {
                categories: {
                    title: 'Категория',
                    srcName: 'categories', //name of store arr
                    srcKeyVal: 'CategoryID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'categoriesValuesArr',
                    isDefault: true, //если default, то параметры не отправляются в запрос
                    apiFilterName: 'categories'
                },
                types: {
                    title: 'Вид изделия',
                    srcName: 'typesByCategories',
                    srcKeyVal: 'TypeID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'typesValuesArr',
                    isDefault: true,
                    apiFilterName: 'types'
                },
                materials: {
                    title: 'Материал',
                    srcName: 'materials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'materialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'materials'
                },
                finenesses: {
                    title: 'Проба',
                    srcName: 'finenessesByMaterials',
                    srcKeyVal: 'FinenessID',
                    srcKeyTitle: 'Value',
                    value: [],
                    defaultValArrName: 'finenessesValuesArr',
                    isDefault: true,
                    apiFilterName: 'finenesses'
                },
                insertMaterials: {
                    title: 'Материал вставки',
                    srcName: 'insertMaterials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'insertMaterialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'inserts_materials'
                },
                collections: {
                    title: 'Коллекция',
                    srcName: 'supplierCollections',
                    srcKeyVal: 'CollectionID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'supplierCollectionsValuesArr',
                    isDefault: true,
                    apiFilterName: 'collections'
                },
                visibility: {
                    title: 'Видимость',
                    srcName: 'supplierVisibility',
                    srcKeyVal: 'id',
                    srcKeyTitle: 'title',
                    value: [],
                    defaultValArrName: 'visibilityOptionsArr',
                    isDefault: true,
                    apiFilterName: 'accesses'
                }
            },
            level1mFilter: false,
            level2mFilter: false,
            pageSizes,
            mobileMassActions,
            selectedProducts: [],
            loading: true,
            isOpenChangeVisibilityMass: false,
            isOpenDeleteMass: false,
            isOpenChangeCollectionMass: false,
            isOpenChangeGarnitureMass: false,
            isCreateCollectionOpen: false,
            previousModalName: '', // 'changeCollectionMass', 'manageCollection'

            isOpenManageCollectionsSubmenu: false,
            isOpenManageCollection: false,
            manageCollectionId: '',
            isOpenDeleteCollection: false
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('supplierProducts', [
            'products',
            'errors',
            'mobileProducts',
            'pagination'
        ]),
        ...mapState('categories', { categories: 'supplierCategories' }),
        ...mapGetters('categories', {
            categoriesValuesArr: 'supplierCategoriesValuesArr'
        }),
        ...mapState('types', { types: 'supplierTypes' }),
        ...mapGetters('types', {
            getTypesByCategories: 'getSupplierTypesByCategories',
            typesValuesArr: 'supplierTypesValuesArr'
        }),
        ...mapState('materials', { materials: 'supplierMaterials' }),
        ...mapGetters('materials', {
            materialsValuesArr: 'supplierMaterialsValuesArr'
        }),
        ...mapState('finenesses', { finenesses: 'supplierFinenesses' }),
        ...mapGetters('finenesses', {
            getFinenessesByMaterials: 'getSupplierFinenessesByMaterials',
            finenessesValuesArr: 'supplierFinenessesValuesArr',
            getFinenessesNamesArr: 'getSupplierFinenessesNamesArr'
        }),
        ...mapState('insert', { insertMaterials: 'supplierInsertMaterials' }),
        ...mapGetters('insert', {
            insertMaterialsValuesArr: 'supplierInsertMaterialsValuesArr'
        }),
        ...mapState('purposes', ['purposes']),
        ...mapState('supplierCollections', [
            'collections',
            'supplierCollections'
        ]),
        ...mapGetters('supplierCollections', [
            'getCollectionBrandId',
            'supplierCollectionsValuesArr'
        ]),
        ...mapState('other', ['visibilityOptions']),
        ...mapGetters('other', ['supplierVisibility', 'visibilityOptionsArr']),
        typesByCategories() {
            return this.getTypesByCategories(this.filter.categories.value)
        },
        finenessesByMaterials() {
            return this.getFinenessesByMaterials(this.filter.materials.value)
        },
        finenessesNamesArr() {
            return this.getFinenessesNamesArr(this.filter.finenesses.value)
        },
        isAllDefaultValues() {
            return (
                Object.keys(this.filter).filter(
                    item => !this.filter[item].isDefault
                ).length === 0
            )
        },
        appliedFiltersCount() {
            return Object.keys(this.filter).filter(
                item => this.filter[item].value.length
            ).length
        },
        paginatedProducts() {
            if (document.documentElement.clientWidth > 1024) {
                return this.products
            }
            return this.mobileProducts
        },
        massCollectionBrandId() {
            if (!this.selectedProducts.length) return ''
            let brandsIds = {} //test same brand
            this.selectedProducts.forEach(id => {
                let product = this.paginatedProducts.find(
                    paginatedProduct => paginatedProduct.ItemID == id
                )

                if (product) {
                    brandsIds[product.BrandID] = true
                }
            })
            return Object.keys(brandsIds).length === 1
                ? parseInt(Object.keys(brandsIds)[0])
                : ''
        },
        isMassCategoryCorrect() {
            if (!this.selectedProducts.length) return false
            let categoryIds = {} //test same category
            this.selectedProducts.forEach(id => {
                let product = this.paginatedProducts.find(
                    paginatedProduct => paginatedProduct.ItemID == id
                )

                if (product) {
                    categoryIds[product.CategoryID] = true
                }
            })
            return (
                Object.keys(categoryIds).length === 1 &&
                Object.keys(categoryIds)[0] == 1
            ) //"Украшения"
        },
        manageCollectionBrandId() {
            if (!this.manageCollectionId) return ''
            return this.getCollectionBrandId(this.manageCollectionId)
        },
        createCollectionBrandId() {
            if (this.previousModalName === 'changeCollectionMass')
                return this.massCollectionBrandId
            return this.manageCollectionBrandId
        },
        canChangeBrandForCollection() {
            return (
                this.previousModalName === 'manageCollection' &&
                !this.manageCollectionBrandId
            )
        }
    },
    beforeRouteEnter(to, from, next) {
        const lsSearch = window.localStorage.getItem('productsSearch')

        const lsPage = window.localStorage.getItem('productsPage')

        const lsFilters = JSON.parse(
            window.localStorage.getItem('productsFilter') || '{}'
        )

        const notDefault = Object.keys(lsFilters).filter(
            item => !lsFilters[item].isDefault
        )

        const parentRouteName =
            from && from.matched.length ? from.matched[0].name : ''

        next(vm => {
            //если переданы настройки фильров в параметрах роута, то используем их
            //иначе, если был переход со страницы редактирования изделия, то берем настройки из ls

            if (Object.keys(vm.$route.params).length) {
                if (vm.$route.params.type_id) {
                    vm.filter.types.value = new Array(1).fill(
                        vm.$route.params.type_id
                    )
                    vm.onFilterChange('types')
                }

                if (vm.$route.params.category_id) {
                    vm.filter.categories.value = new Array(1).fill(
                        vm.$route.params.category_id
                    )
                    vm.onFilterChange('categories')
                }

                if (vm.$route.params.collection_id) {
                    vm.filter.collections.value = new Array(1).fill(
                        vm.$route.params.collection_id
                    )
                    vm.onFilterChange('collections')
                }

                console.log('Filter types installed from route params')
            } else if (
                ['SupplierProductsEdit', 'SupplierProductsDetail'].includes(
                    parentRouteName
                )
            ) {
                if (notDefault.length) {
                    notDefault.forEach(filterKey => {
                        vm.filter[filterKey].value = lsFilters[filterKey].value
                        vm.onFilterChange(filterKey)
                    })
                    console.log('Filters installed from ls')
                }

                if (lsSearch) {
                    vm.search = lsSearch
                    vm.updateProductsList(1)
                }

                if (lsPage && !vm.isMobile) {
                    vm.onSetPage(lsPage)
                }
            }
        })
    },
    beforeRouteLeave(to, from, next) {
        if (this.isAllDefaultValues) {
            window.localStorage.removeItem('productsFilter')
        } else {
            window.localStorage.setItem(
                'productsFilter',
                JSON.stringify(this.filter)
            )
        }

        if (this.search) {
            window.localStorage.setItem('productsSearch', this.search)
        } else {
            window.localStorage.removeItem('productsSearch')
        }

        if (this.pagination.page > 1) {
            window.localStorage.setItem('productsPage', this.pagination.page)
        } else {
            window.localStorage.removeItem('productsPage')
        }

        next()
    },
    async mounted() {
        //выполняем после beforeRouteEnter
        this.$nextTick(async () => {
            this.tryLoadingProducts()
        })
    },
    async destroyed() {
        this.clearProducts()
    },
    methods: {
        ...mapMutations('supplierProducts', ['SET_PAGINATION']),
        ...mapActions('supplierProducts', ['getProducts']),
        ...mapActions('supplierProducts', ['clearProducts']),
        ...mapActions('categories', ['getCategories']),
        ...mapActions('types', ['getTypes']),
        ...mapActions('materials', ['getMaterials']),
        ...mapActions('finenesses', ['getFineness']),
        ...mapActions('purposes', ['getPurposes']),
        ...mapActions('insert', ['getInsertMaterials']),
        ...mapActions('supplierCollections', ['getCollections']),
        ...mapActions('other', ['getVisibility']),
        onSelectPickerChange(type, val) {
            this.filter[type].value = val
            this.onFilterChange(type)
        },
        setFilters() {
            if (!this.categories.length) {
                this.getCategories({ existing: true, sort_by: 'Position' })
            }

            if (!this.types.length) {
                this.getTypes({ existing: true })
            }

            if (!this.materials.length) {
                this.getMaterials({ existing: true })
            }

            if (!this.finenesses.length) {
                this.getFineness({ existing: true })
            }

            if (!this.insertMaterials.length) {
                this.getInsertMaterials({ existing: true })
            }

            if (!this.supplierCollections.length) {
                this.getCollections({ existing: true })
            }

            if (!this.supplierVisibility.length) {
                this.getVisibility({ existing: true })
            }
        },
        setlevel2mFilters(filterKey) {
            this.level2mFilter = filterKey
        },
        resetFilters() {
            Object.keys(this.filter).forEach(item => {
                this.filter[item].isDefault = true
                this.filter[item].value = []
            })
            this.updateProductsList(1)
            this.closeAllmFilters()
        },
        closeAllmFilters() {
            this.level2mFilter = false
            this.level1mFilter = false
        },
        getNameById_old(filterKey, filterValue) {
            const src = this[this.filter[filterKey].srcName]

            const item = src.find(el => {
                if (el[this.filter[filterKey].srcKeyVal] == filterValue) {
                    return el
                }
            })

            if (item) return item[this.filter[filterKey].srcKeyTitle]
            return ''
        },
        onFilterChange(filterType) {
            this.filter[filterType].isDefault = !this.filter[filterType].value
                .length

            this.updateProductsList(1)
        },
        updateProductsList: _.debounce(function(
            page = 1,
            isMobilePagination = false
        ) {
            this.updateProductsListFunc(page, isMobilePagination)
        },
        800),
        async updateProductsListFunc(page = 1, isMobilePagination = false) {
            this.loading = true
            this.$Progress.start()
            this.selectedProducts = []

            let data = { page, isMobilePagination }
            Object.keys(this.filter).forEach(item => {
                if (!this.filter[item].isDefault) {
                    let valuesArr = [...this.filter[item].value]

                    if (item === 'finenesses') {
                        valuesArr = [...this.finenessesNamesArr]
                    }

                    if (!valuesArr.length) {
                        valuesArr = [null]
                    }

                    data[this.filter[item].apiFilterName] = valuesArr
                }
            })

            if (this.search) {
                data.search = this.search
            }

            await this.getProducts(data)

            this.loading = false
        },
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.updateProductsList(page)
        },
        onPageSizeChange(val) {
            this.SET_PAGINATION({
                key: 'pageSize',
                val
            })

            this.updateProductsList(1)
        },
        onSelectProducts(val) {
            let index = this.selectedProducts.indexOf(val)
            if (index > -1) {
                this.selectedProducts.splice(index, 1)
            } else {
                this.selectedProducts.push(val)
            }
        },
        onSelectAllProducts() {
            if (
                this.selectedProducts.length === this.paginatedProducts.length
            ) {
                this.selectedProducts = []
            } else {
                this.selectedProducts = this.paginatedProducts.map(
                    item => item.ItemID
                )
            }
        },
        onCloseChangeVisibilityMass() {
            this.isOpenChangeVisibilityMass = false
            this.selectedProducts = []
        },
        onCloseDeleteMass() {
            this.isOpenDeleteMass = false
            this.selectedProducts = []
        },
        onCloseChangeCollectionMass() {
            this.isOpenChangeCollectionMass = false
            this.selectedProducts = []
        },
        onCloseChangeGarnitureMass() {
            this.isOpenChangeGarnitureMass = false
            this.selectedProducts = []
        },
        onChangeVisibilityMassSaved() {
            this.updateProductsList(this.pagination.page)
            this.clearSupplierCatalogFilterDict('supplierVisibility')
            this.getVisibility({ existing: true })
        },
        onDeleteMassSaved() {
            this.updateProductsList(this.pagination.page)
            this.clearSupplierCatalogFilterDict()
            this.setFilters()
        },
        onMobileActionSelect(val) {
            switch (val) {
                case 0:
                    this.isOpenChangeVisibilityMass = true
                    break
                case 1:
                    if (!this.massCollectionBrandId) return
                    this.isOpenChangeCollectionMass = true
                    break
                case 2:
                    this.isOpenDeleteMass = true
                    break
                case 3:
                    if (
                        this.selectedProducts.length >= 6 ||
                        !this.isMassCategoryCorrect ||
                        !this.massCollectionBrandId
                    )
                        return
                    this.isOpenChangeGarnitureMass = true
                    break
            }
        },
        onChangeCollectionMassSaved() {
            this.updateProductsList(this.pagination.page)
            this.clearSupplierCatalogFilterDict('supplierCollections')
            this.getCollections({ existing: true })
        },
        onChangeGarnitureMassSaved() {
            this.updateProductsList(this.pagination.page)
        },
        onAddCollectionClick(prevModalName) {
            this.previousModalName = prevModalName

            this.isOpenChangeCollectionMass = false
            this.isOpenManageCollection = false
            this.isCreateCollectionOpen = true
        },
        onCreateCollectionClose() {
            this.isCreateCollectionOpen = false
            this.manageCollectionId = ''
        },
        onCreateCollectionSave() {
            this.manageCollectionId = ''

            switch (this.previousModalName) {
                case 'changeCollectionMass':
                    this.isOpenChangeCollectionMass = true
                    break
                case 'manageCollection':
                    this.isOpenManageCollection = true
                    break
            }
        },
        onCreateCollectionBack() {
            this.isCreateCollectionOpen = false
            this.onCreateCollectionSave()
        },
        toggleManageCollectionsSubmenu() {
            this.isOpenManageCollectionsSubmenu = !this
                .isOpenManageCollectionsSubmenu
        },
        closeManageCollectionsSubmenu() {
            this.isOpenManageCollectionsSubmenu = false
        },
        openDeleteCollection(id) {
            this.manageCollectionId = id
            this.isOpenDeleteCollection = true
            this.isOpenManageCollection = false
        },
        onDeleteCollectionClose() {
            this.manageCollectionId = ''
            this.isOpenDeleteCollection = false
        },
        onDeleteCollectionSave() {
            this.manageCollectionId = ''
            this.getCollections()
            this.getCollections({ existing: true })
            this.updateProductsList(this.pagination.page)
        },
        openUpdateCollection(id) {
            this.manageCollectionId = id

            this.onAddCollectionClick('manageCollection')
        },

        onChangeProductVisibility(productId) {
            this.selectedProducts = [productId]
            this.isOpenChangeVisibilityMass = true
        },
        onChangeProductCollection(productId) {
            this.selectedProducts = [productId]
            this.isOpenChangeCollectionMass = true
        },
        onDeleteProduct(productId) {
            this.selectedProducts = [productId]
            this.isOpenDeleteMass = true
        },

        onSearch() {
            this.$Progress.start()
            this.updateProductsList(1)
        },
        onClearSearch() {
            this.search = ''
            this.$Progress.start()
            this.updateProductsList(1)
        },
        async tryLoadingProducts() {
            const lsPage = window.localStorage.getItem('productsPage')
            if (this.isAllDefaultValues && !this.search && !lsPage) {
                await this.updateProductsListFunc(1)
            } else {
                await this.updateProductsList(lsPage || 1)
            }

            this.setFilters()
            this.getCollections()
        }
    }
}
</script>
